//사용x

// 타입 안전 변환 유틸
export const toStringSafe = (value: any): string =>
  value !== undefined && value !== null ? String(value) : '';

export const toNumberSafe = (value: any): number | undefined => {
  const num = Number(value);
  return isNaN(num) ? undefined : num;
}; 